import { Height } from '@mui/icons-material'
import { Box, Container, Grid, styled } from '@mui/material'
import React, { Children, ReactNode } from 'react'

interface SquareGridProps {
  boxStyles?: React.CSSProperties
  containerStyles?: React.CSSProperties
  children: React.ReactNode
  itemSize: number
  gap: number
}

const SquareGrid = ({ children, itemSize, gap, containerStyles, boxStyles }: SquareGridProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        padding: '4px',
        border: '1px #CCD4DC solid',
        borderRadius: '5px',
        width: `${itemSize * 2 + gap + 10}px`,
        height: `${itemSize * 2 + gap + 10}px`,
        gap: `${gap}px`, // Space between items
        ...containerStyles,
      }}
    >
      {React.Children.map(children, (child, index) => (
        <Box
          sx={{
            width: `${itemSize}px`,
            height: `${itemSize}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#ddd',
            borderRadius: '3px',
            boxSizing: 'border-box',
            ...boxStyles,
          }}
          key={index}
        >
          {child}
        </Box>
      ))}
    </Box>
  )
}

export default SquareGrid
